import { ChangeDetectionStrategy, Component, Input, OnChanges, inject, signal } from '@angular/core';

import { TipoPreviaMensagemEnum } from '../../../shared/enum/tipo-previa-mensagem.enum';
import { UltimaMensagemPrevia } from '../../../shared/model/contato/ultima-mensagem-previa.model';
import { AuthService } from '../../../shared/service/auth.service';
import { DuracaoAudioService } from '../../../shared/service/duracao-audio.service';
import { MethodsUtils } from '../../../shared/util/methods.utils';
import { StatusMensagemComponent } from '../../status-mensagem/status-mensagem.component';
import { ROTULOS_TIPO_PREVIA } from '../../utils/chat.constantes';
import { ALVO_REACAO_PADRAO, ALVO_REACAO_POR_TIPO, ICONES_PREVIA_MENSAGEM, TIPOS_PREVIA_SOMENTE_ROTULO } from './utils/previa-mensagem.constantes';

@Component({
  selector: 'app-previa-mensagem',
  standalone: true,
  imports: [StatusMensagemComponent],
  templateUrl: './previa-mensagem.component.html',
  styleUrl: './previa-mensagem.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PreviaMensagemComponent implements OnChanges {
  @Input() previa?: UltimaMensagemPrevia;
  @Input() textoAlternativo?: string;

  readonly texto = signal('');
  readonly icone = signal<string | null>(null);
  readonly mostraStatus = signal(false);

  private readonly duracaoAudioService = inject(DuracaoAudioService);
  private readonly usuarioId = inject(AuthService).getUsuarioLogadoClariBot()?.id;
  private urlAudioAtual?: string;

  ngOnChanges(): void {
    const previa = this.previa;
    this.urlAudioAtual = undefined;
    if (!previa?.tipo) {
      this.icone.set(null);
      this.mostraStatus.set(false);
      this.texto.set(this.textoAlternativo || '-');
      return;
    }
    const ehReacao = previa.tipo === TipoPreviaMensagemEnum.REACAO;
    this.icone.set(ICONES_PREVIA_MENSAGEM[previa.tipo] ?? null);
    this.mostraStatus.set(!ehReacao && !previa.enviadaPeloCliente && !!previa.status);
    this.texto.set(ehReacao ? this.textoReacao(previa) : this.textoMensagem(previa));
    if (previa.tipo === TipoPreviaMensagemEnum.AUDIO && previa.urlArquivo) this.carregarDuracao(previa.urlArquivo);
  }

  private textoMensagem(previa: UltimaMensagemPrevia): string {
    if (previa.texto?.trim() && !TIPOS_PREVIA_SOMENTE_ROTULO.includes(previa.tipo)) return MethodsUtils.formatarMensagemComNegritoItalicoRiscada(previa.texto, true);
    return ROTULOS_TIPO_PREVIA[previa.tipo];
  }

  private textoReacao(previa: UltimaMensagemPrevia): string {
    const alvo = previa.texto?.trim()
      ? `"${MethodsUtils.formatarMensagemComNegritoItalicoRiscada(previa.texto, true)}"`
      : (previa.tipoMensagemReagida && ALVO_REACAO_POR_TIPO[previa.tipoMensagemReagida]) || ALVO_REACAO_PADRAO;
    return `${this.autorReacao(previa)} com ${previa.emoji ?? ''} a ${alvo}`;
  }

  private autorReacao(previa: UltimaMensagemPrevia): string {
    if (previa.enviadaPeloCliente) return 'Reagiu';
    if (previa.usuarioId == null || previa.usuarioId === this.usuarioId || !previa.usuarioNome) return 'Você reagiu';
    return `${previa.usuarioNome} reagiu`;
  }

  private carregarDuracao(url: string): void {
    this.urlAudioAtual = url;
    this.duracaoAudioService.buscar(url).then(duracao => {
      if (duracao != null && this.urlAudioAtual === url) this.texto.set(MethodsUtils.formatarTempoMidia(duracao));
    });
  }
}
